export const invitationErrorMessages = {
    invitation: {
        id: {
            required: "Invitation's id cannot be empty",
            uuid: "Invitation's id must be uuid",
            duplicate: 'Invitation id already exists',
        },
        emailFilters: {
            email: {
                required: "Invitation's email filters value cannot be empty",
                format: "Invitation's email filters value must be an email",
                invited: 'User with that email is already invited',
                member: 'User with that email is already a member',
                duplicate: 'User with that email is already included',
            },
            empty: 'Email filters cannot be empty',
            required: 'Email filters are required when creating individual invitation',
        },
        members: {
            empty: 'Can not create individual invite for 0 users',
        },
        emailFilter: {
            required: "Invitation's email filter value cannot be empty",
            format: "Invitation's email filter value must be an email",
        },
        organizationDomain: 'You must set organization domain first',
        organization: 'Organization invitation already created',
        migration: {
            alreadyExists: 'Migration invitation already exists',
        },
        member: {
            required: 'Invitation must have a member',
            alreadyExists: 'The user is already a member of this workspace',
        },
        limitExceeded: 'You have reached the limit of members to invite',
        guest: {
            email: {
                required: "Invitation's email value cannot be empty",
                format: "Invitation's email filters value must be an email",
                member: 'User with that email is already a member',
                duplicate: 'User with that email is already included',
            },
            maxBatchExceeded: 'You have exceeded the maximum number of guests you can invite at once',
            required: 'Guest invitation is required',
        },
    },
    acceptInvitation: {
        alreadyMember: 'Member for the current user already exists',
        individualInvitationExists: 'There is individual invitation for the current user',
        notForCurrentUser: 'This invitation is not for the current user',
        missingCrypto: 'This invitation should contain crypto',
    },
    declineInvitation: {
        notPending: 'The invitation is no longer pending',
        notAllowed: 'This membership cannot be declined',
        scimManaged: 'This membership is managed by your identity provider',
    },
};
